import { Card } from "@lya-protect/lya-protect-form-library/dist/UI";
import { environment } from "@src/MarqueBlanche";
import classNames from "classnames";
import "./offreCard.scss";

type CardDownloadProps = {
  hidden?: boolean;
  // selectedOffre: Offre;
};
export function OffreCardDownload({
  hidden,
}: // selectedOffre,
CardDownloadProps) {
  return (
    <Card
      variant="outline"
      className={classNames(
        "nos-offres-card-download",
        hidden && "nos-offres-card-download--hidden"
      )}
    >
      <a
        href={environment.current.docDIPA}
        target="_blank"
        className="nos-offres-card-download__download-link"
        rel="noreferrer"
      >
        Document d&apos;information sur le produit d&apos;assurance
      </a>
      <a
        href={environment.current.docReglement}
        target="_blank"
        className="nos-offres-card-download__download-link"
        rel="noreferrer"
      >
        Réglement mutualiste
      </a>
      <a
        href={environment.current.docStatut}
        target="_blank"
        className="nos-offres-card-download__download-link"
        rel="noreferrer"
      >
        Statuts mutualistes
      </a>
    </Card>
  );
}
